import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TscreenType } from '../hooks/useGetScreenType'

interface IUiSlice {
    screenType: TscreenType
    incompleteEmailSettingModalVisible: boolean
    registerAs?: 'Teacher' | 'School'

    errorMsg?: string | { title: string; desc: string }

    fbStatus?: boolean
}

const initialState: IUiSlice = {
    screenType: 'PC',
    incompleteEmailSettingModalVisible: false,
}

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setScreenType: (state, action: PayloadAction<TscreenType>) => {
            state.screenType = action.payload
        },
        setIncompleteEmailSettingModalVisible: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.incompleteEmailSettingModalVisible = action.payload
        },
        setRegisterAs: (
            state,
            action: PayloadAction<'Teacher' | 'School' | undefined>
        ) => {
            state.registerAs = action.payload
        },
        setErrorMsg: (
            state,
            action: PayloadAction<
                string | { title: string; desc: string } | undefined
            >
        ) => {
            state.errorMsg = action.payload
        },
        setFbStatus: (state, action: PayloadAction<boolean | undefined>) => {
            state.fbStatus = action.payload
        },
    },
})

export const {
    setScreenType,
    setIncompleteEmailSettingModalVisible,
    setRegisterAs,
    setErrorMsg,
    setFbStatus,
} = uiSlice.actions

export default uiSlice.reducer
